//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions } from "vuex";
import {RESPONSE_SUCCESS} from "@/contants/api";

export default {
  layout: "frontend/auth",
  data() {
    return {
      email: null,
      password: null,
      formErrors: {}
    };
  },
  computed: {
    messageError() {
      return (fromVee, fromAPI) => {
        return fromVee[0] || (this.formErrors[fromAPI] && this.formErrors[fromAPI][0])
      }
    }
  },
  methods: {
    ...mapActions({
      login: 'frontend/auth/login',
      saveAuth: 'frontend/auth/saveAuth',
      getUserInfo: 'frontend/auth/getUserInfo',
    }),
    async onLogin() {
      this.$nuxt.$loading.start()
      let email, password;
      email = this.email;
      password = this.password;
      const data = await this.login({email, password});
      if (!data.errorCode) {
        this.saveAuth(data)
        await this.getUserInfo()
        return this.$router.push('/dashboard')
      } else {
        this.$notify.error({title: data.data.message})
        // this.formErrors = data?.data?.data || {}
      }
      this.$nuxt.$loading.finish()
    }
  },
}
